import { Injectable } from '@angular/core';
import { BBService, BBModel } from 'bookingbug-core-js';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import moment from 'moment';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AmazonService {
  private core = AppConfig.settings.core;
  private apiServer = AppConfig.settings.apiServer;
  member;

  constructor(private http: HttpClient) { }

  async osGetNameDataEncodedApi(postcode: string) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };
      return await this.http
        .get(`${environment.apiServer}/ordnance_survey/postcode/${postcode}`, {
          headers,
        })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getFormSchema(formId: string, company_id, companyName) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };
      const data = {
        company: company_id,
        client: `${companyName}`,
        form_name: `${formId}`,
      };
      return await this.http
        .post(`${environment.apiServer}/form/schema`, data, { headers })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async putPermitApplicationOperation(
    data: any,
    company_id,
    companyName,
    operation,
    annual_allowance,
    day_allowance
  ) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };
      let body: any = {};
      body.data = data;
      body.function = operation;
      body.company = company_id;
      body.client = `${companyName}`;
      body.annual_allowance = annual_allowance;
      body['1_day_allowance'] = day_allowance;
      return await this.http
        .put(`${environment.apiServer}/permitApplications`, body, { headers })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async checkPermitApplicationOperation(
    company_id,
    companyName,
    permit_id,
    operation,
    vehicleReg = ''
  ) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };
      let body: any = {};
      body.function = operation;
      body.company = company_id;
      body.permit_id = permit_id;
      body.vehicleReg = vehicleReg;
      body.client = `${companyName}`;

      return await this.http
        .put(`${environment.apiServer}/permitApplications`, body, { headers })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async uploadFile(file: object) {
    const headers = {
      'Content-Type': 'application/json',
      'no-loader': 'no-loader',
      clienttoken: environment.clientToken,
    };
    return await this.http
      .post(`${environment.apiServer}/upload`, file, { headers })
      .toPromise();
  }

  async emailTemplateSender(commsData: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'no-loader': 'no-loader',
        clienttoken: environment.clientToken,
      };

      return await this.http
        .post(`${environment.apiServer}/emailTemplateSender`, commsData, {
          headers,
        })
        .toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

  async getBooking(booking_id, company_id) {
    const headers = {
      'Content-Type': 'application/json',
      'clienttoken': environment.clientToken
    };

    return await this.http.get(`${environment.apiServer}/company/${company_id}/booking/${booking_id}`, { headers }).toPromise();
  }

  sendStatusUpdate(companyId: number, booking: any, config: any) {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'clienttoken': environment.clientToken
      };
      booking._data = JSON.parse(JSON.stringify(booking))
      booking.config = config
      booking.pushType = "new"
      booking.clientName = config.host.split("//")[1].split(".")[0]
      booking.companyId = companyId

      return this.http.post(`${environment.apiServer}/notifications/add-booking`, booking, { headers }).toPromise();
    } catch (error) {
      return (error as Error).message;
    }
  }

    async getConfig() {
    // console.log(`Loading '${environment.companyName}' config.`);
    const headers = {
      'Content-Type': 'application/json',
      'clienttoken': environment.clientToken
    };
    const companyName = AppConfig.settings.apiServer.api_url.split("://")[1].split(".")[0]
    const body = {
      "client": `${companyName}`,
      "company": `${AppConfig.settings.core.company_id}`
    }

    return await this.http.post(`${environment.apiServer}/config`, body, { headers }).toPromise();
  }
}
